import { Injectable } from '@angular/core';
import { environment } from 'src/environments/default/environment';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
    readonly data = environment;
}